import arrayBufferViewCore from './array-buffer-view-core.js';
import speciesConstructor$1 from './species-constructor.js';

var ArrayBufferViewCore = arrayBufferViewCore;
var speciesConstructor = speciesConstructor$1;
var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor; // a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create

var typedArraySpeciesConstructor = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
};

export { typedArraySpeciesConstructor as default };
